import { get as _get } from "lodash";
import { AxiosError, AxiosResponse } from "axios";

export function errorIsStatus (err: AxiosError|unknown, status: number) {
  return _get(err, "response.status") === status;
}

export function getErrorMessage (error: any) {
  const errorMessage = _get(error, "response.data.errorMessage");
  return typeof errorMessage === "string" ? errorMessage : "";
}

export function serviceCallNotFoundWithDefault<T> (promise: Promise<AxiosResponse<T>>, defaultFunction: () => T) {
  return promise
      .then(r => r.data)
      .catch(err =>
      errorIsStatus(err, 404) ? Promise.resolve(defaultFunction())
          : Promise.reject(err));
}
